<template>
<button class="select-none">
    <span><slot /> <Arrow/></span>
</button>
</template>

<script>
import Arrow from "../Components/Vector/Arrow.vue";

export default {
	name: "ButtonElement",
	components: {Arrow}
};
</script>

<style lang="scss" scoped>
button {
    --button-size: 14px;
    --button-leading: 22px;
    --button-padding: 12px 30px;
    --button-border: 2px solid black;
    --shadow-offset: 6px;
    position: relative;
    outline: none;

    @media (min-width: 1024px) {
        --button-size: 16px;
        --button-leading: 24px;
        --button-padding: 16px 40px;
        --button-border: 4px solid black;
        --shadow-offset: 8px;
    }


    &::before {
        content: "";
        display: block;
        position: absolute;
        top: var(--shadow-offset);
        left: var(--shadow-offset);
        width: 100%;
        height: 100%;
        background: var(--button-shadow-color);
        border: var(--button-border);
        border-radius: 10px;
        z-index: 1;
    }

    span {
        background: var(--button-color);
        padding: var(--button-padding);
        font-size: var(--button-size);
        line-height: var(--button-leading);
        border: var(--button-border);
        border-radius: 10px;
        color: white;
        font-weight: 800;
        text-transform: uppercase;
        position: relative;
        z-index: 2;
        display: flex;
        gap: 10px;
        align-items: center;
        transition: transform .2s;
    }

    &:focus span {
        border-color: #333;
    }

    &:active span {
        background: var(--button-active-color);
        transform: translate(var(--shadow-offset), var(--shadow-offset));
    }
}
</style>
